/*
 *   Copyright (c) 2021 vlinder Inc.
 *   All rights reserved.
 *   This software is proprietary of vlinder Inc. and can not be distributed / used for any purpose outside of vlinder Inc. without explicit written consent from the copyright owner.
 */
import { Client, Provider, cacheExchange, fetchExchange } from 'urql';
import { PlatformProvider } from '@common/PlatformProvider';

export class Graphql {
  private client!: Client;
  private baseUrl!: string;
  private exchanges!: any[];
  private headers: Record<string, any>;
  constructor() {
    this.exchanges = [fetchExchange];
    const plt = PlatformProvider.getInstance();
    this.headers = plt.getPlatform();
  }

  static create(): Graphql {
    return new this();
  }

  static withBaseUrl(baseUrl: string): Graphql {
    return new this().withBaseUrl(baseUrl?.trim());
  }

  withBaseUrl(baseUrl: string): this {
    if (typeof baseUrl !== 'string') {
      throw new Error(
        `The base URL must be a string. Received "${typeof baseUrl}"`
      );
    }

    this.baseUrl = baseUrl?.trim();

    return this;
  }

  withExchanges(exchanges: any[]) {
    if (exchanges && exchanges.length > 0) {
      this.exchanges = [...this.exchanges, ...exchanges];
    }
  }

  withHeaders(headers: Record<string, any>): this {
    this.headers = { ...this.headers, ...headers };
    return this;
  }

  getClient() {
    this.client = new Client({
      url: this.baseUrl,
      exchanges: this.exchanges,
      fetchOptions: () => {
        return {
          headers: this.headers,
        };
      },
    });
    return this.client;
  }
}
